import React, { useState } from 'react';
import {
    Container,
    Dropdown,
    DropdownItem,
    DropdownToggle,
    DropdownMenu,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faFileExport, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

import { capitalProjectService } from 'services';

import { ProjectReviewWizardForm } from 'components';

import { TabEnum, FormEnum, UrlEnum, ConfirmActionModal } from 'shared';

export const ProjectReviewPage = props => {
    const [stepNumber, setStepNumber] = useState(1);
    Object.filter = (obj, predicate) =>
        Object.fromEntries(Object.entries(obj).filter(predicate));
    const parseQueryParams = () => {
        const query = props.location.state;
        const persistedProjectId = sessionStorage.getItem('projectReviewProjectId');

        if (props.location.hash) {
            const filtered = Object.filter(
                TabEnum,
                ([name, tab]) => tab === props.location.hash
            );
            if (filtered) {
                const NameOfTab = Object.keys(filtered)[0];
                const newStepNumber = FormEnum[NameOfTab];
                if (newStepNumber !== stepNumber) setStepNumber(newStepNumber);
            }
        }
        if (query) {
            for (let param of query) {
                if (
                    param.projectReviewProjectId &&
                    (!persistedProjectId ||
                        param.projectReviewProjectId !== persistedProjectId)
                ) {
                    window.sessionStorage.setItem(
                        'projectReviewProjectId',
                        param.projectReviewProjectId
                    );
                    return param.projectReviewProjectId;
                } else {
                    return null;
                }
            }
        }
    };
    parseQueryParams();
    const persistedProjectId = sessionStorage.getItem('projectReviewProjectId');

    return (
        <Container fluid>
            <ProjectReviewHeader projectId={persistedProjectId}></ProjectReviewHeader>
            <ProjectReviewWizardForm
                projectId={persistedProjectId}
                stepNumber={stepNumber}
            />
        </Container>
    );
};

const ProjectReviewHeader = ({ projectId }) => {
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    return (
        <React.Fragment>
            <div className="d-md-flex align-items-center justify-content-between mb-3">
                <a href={UrlEnum.PROJECTREVIEWSEARCH}>
                    <FontAwesomeIcon icon={faArrowLeft} /> back to search
                </a>
                <div className="d-flex align-items-center">
                    <ExportDropdown projectId={projectId} />
                    <button className="btn btn-danger btn-xs">
                        <FontAwesomeIcon icon={faTrashAlt} /> Delete
                    </button>
                </div>
            </div>
            <ConfirmActionModal
                isOpen={isDeleteModalOpen}
                toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
                header={`Confirm Delete`}
                message={'Are you sure you want to delete this capital project?'}
                acceptButtonText={'Delete'}
                acceptFunction={() =>
                    capitalProjectService
                        .deleteCapitalProject(projectId)
                        .then((window.location.href = UrlEnum.PROJECTREVIEWSEARCH))
                }
                acceptButtonCss="btn btn-danger"
            />
        </React.Fragment>
    );
};

const ExportDropdown = ({ projectId }) => {
    const [isOpen, updateIsOpen] = useState(false);

    return (
        <React.Fragment>
            <Dropdown
                className="dropdown mr-2"
                onMouseOver={() => updateIsOpen(true)}
                onFocus={() => updateIsOpen(true)}
                // onMouseLeave={() => updateIsOpen(false)}
                onBlur={() => updateIsOpen(false)}
                toggle={() => updateIsOpen(!isOpen)}
                isOpen={isOpen}
                direction="down"
            >
                <DropdownToggle className="btn btn-xs btn-outline-primary dropdown-toggle">
                    <FontAwesomeIcon icon={faFileExport} />
                    Export as...
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem
                        onClick={() =>
                            capitalProjectService.downloadCapitalProject('xls', projectId)
                        }
                    >
                        XLS
                    </DropdownItem>
                    <DropdownItem
                        onClick={() =>
                            capitalProjectService.downloadCapitalProject('pdf', projectId)
                        }
                    >
                        PDF
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};
